// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "G_b1";
export var authorBioEditorialContainer = "G_b0";
export var authorBioEditorialXp = "G_b2";
export var authorBioPageContainer = "G_bZ";
export var relatedArticles = "G_x";